import { ReactNode, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal, PHONE_VERIFICATION_ACTION, phoneVerification } from '~/actions';
import { Typography } from '@tempmee/react';
import { Center, ConfirmPopup } from '~/commonComponents';
import { VerificationInput } from '~/commonComponents/VerificationInput';
import { useAppSelector, useLoading } from '~/hooks';
import { useTrackEvent } from '~/hooks/useTrackEvent';
import { POSTHOG_EVENTS } from '~/services/posthog';

interface IProps {
  tel: string;
}

export const VerifyPhonePopup = ({ tel }: IProps): ReactNode => {
  const isOpen = useAppSelector((state) => state.user.pendingPhoneVerification);
  const dispatch = useDispatch();
  const trackPosthogEvent = useTrackEvent();
  const { isLoading } = useLoading([PHONE_VERIFICATION_ACTION]);

  const [code, setCode] = useState('');

  const onClosePopup = () => dispatch(closeModal());

  const onSubmit = (code: string) => {
    // Track PostHog event for verification code submission
    trackPosthogEvent(POSTHOG_EVENTS.DENTAL_PORTAL_MFA_CODE_SUBMITTED);

    dispatch(phoneVerification({ code, phone: tel }));
  };

  useEffect(() => {
    if (isOpen) {
      trackPosthogEvent(POSTHOG_EVENTS.DENTAL_PORTAL_MFA_POP_UP_VIEWED);
    }
  }, [trackPosthogEvent, isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    // @ts-expect-error - ConfirmPopup still written in Javascript
    <ConfirmPopup
      closePopup={onClosePopup}
      dataCy="confirm-phone-number-popup"
      dataTestId="confirm-phone-number-popup"
      dismissiblePopup={false}
      modalContainerStyle={{ zIndex: 'auto' }}
      rightButtonAction={() => onSubmit(code)}
      rightButtonLoading={isLoading}
      rightButtonText="Submit"
      showClosePopupIcon
    >
      <Typography as="span" bold size="heading_3">
        Confirmation Code
      </Typography>
      <Center marginBottom={32} marginTop={60}>
        <Typography as="span" textAlign="center">We sent you a 5 digit confirmation</Typography>
        <Typography as="span" textAlign="center">
          code to <strong>{tel}</strong>
        </Typography>
      </Center>
      <Center marginBottom={56}>
        <VerificationInput
          onChange={setCode}
          onComplete={(e) => {
            onSubmit(e);
          }}
        />
      </Center>
    </ConfirmPopup>
  );
};
